import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

const OurProjectsStyles = styled.section`
  display: flex;
  justify-content: center;
  box-sizing: border-box;
`

const CheatWrapper = styled.div`
  padding: 58px 200px 80px;
  width: 100%;
  @media only screen and (max-width: 1400px) {
    padding: 58px 120px 80px;
  }
  @media only screen and (max-width: 1200px) {
    padding: 58px 96px 80px;
  }
  @media only screen and (max-width: 800px) {
    padding: 58px 80px 80px;
  }
  @media only screen and (max-width: 700px) {
    padding: 58px 64px 80px;
  }
  @media only screen and (max-width: 600px) {
    padding: 58px 48px 80px;
  }
  @media only screen and (max-width: 500px) {
    padding: 58px 36px 80px;
  }
  @media only screen and (max-width: 400px) {
    padding: 58px 24px 80px;
  }
`

const Main = styled.div`
  display: flex;
  flex-direction: column;
  h2 {
    padding-left: 4px;
    font-family: "Tinos", serif;
    font-style: italic;
    font-weight: bold;
    font-size: 22px;
    line-height: 25px;
    color: #989085;
    align-self: start;
  }
  @media only screen and (max-width: 737px) {
    h2{
      align-self: center;
    }
  }
`
const ProjectBoxWrapper = styled.div`
  box-sizing: border-box;
  margin-top: 18px;
  width: 100%;
  /* height: min-content; */
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
`

const ProjectBox = styled.div`
  padding: 16px;
  background: #f9f3ec;
  display: flex;
  flex-direction: column;
  width: 333px;
  margin-bottom: 64px;
  /* height: 100%; */

  h3 {
    font-family: "Amasis", serif;
    font-style: normal;
    font-weight: bold;
    font-size: 26px;
    line-height: 33px;
    color: #3e3120;
  }
  p {
    margin: 12px 0 16px 0;
    font-family: "Cabin", Sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 170%;
    color: #424242;
  }
  > .link-out {
    margin-top: auto;
    text-decoration: none;
    font-family: "Tinos", serif;
    font-size: 18px;
    font-style: italic;
    font-weight: bold;
    color: #6b3e7d;
    svg{
      margin-left: 8px;
    }
  }
  @media only screen and (max-width: 1300px) {
    width: 300px;
    h3{
      font-size: 24px;
    }
    .link-out{
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 1200px) {
    width: 290px;
  }
`

function OurProjects() {
  return (
    <OurProjectsStyles>
      <CheatWrapper>
        <Main>
          <h2>Our Projects</h2>
          <ProjectBoxWrapper>
            <ProjectBox>
              <h3>Workshops</h3>
              <p>
                In line with our goal to discover new and fledgling talent,
                HEIGHTS organizes workshops for both writers and artists, namely
                the Ateneo HEIGHTS Writers Workshop (AHWW) and the Ateneo
                HEIGHTS Artists Workshop (AHAW). Each year, a group of
                undergraduate students, who are handpicked by a screening
                committee, come together to have their works critiqued by
                distinguished professors of the Ateneo. After the workshop, the
                works of the students are shared to the community through a zine
                (for AHWW) and an exhibit (for AHAW).
              </p>
              <Link to="/contribute" className="link-out">
                Apply for AHWW now
                {/* add svg */}
                <svg
                  width="18"
                  height="7"
                  viewBox="0 0 18 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.2363 2.76367C13.7168 2.15299 13.1745 1.25521 12.6094 0.0703118H13.5937C14.7513 1.42838 15.9818 2.4401 17.2852 3.10547V3.59766C15.9818 4.26302 14.7513 5.27474 13.5937 6.63281H12.6094C13.1745 5.44792 13.7168 4.55013 14.2363 3.93945L0.714843 3.93945V2.76367L14.2363 2.76367Z"
                    fill="#6B3E7D"
                  />
                </svg>
              </Link>
            </ProjectBox>
            <ProjectBox>
              <h3>Kuwentong Pambata</h3>
              <p>
                Kuwentong Pambata is HEIGHTS' main
                external collaboration, conducted with the Sector-Based Cluster
                (SBC) organizations. The Kuwentong Pambata Book Grant is given
                to one writer and one illustrator. Writers and illustrators
                submit their applications and are selected by the Editorial
                Board along with representatives from the SBC organizations.
                They work closely with each other, as well as with a faculty
                mentor to hone their children’s storybook. The book is released
                at launch to recognize the writer and artist’s contributions to
                the project. The publication is distributed during outreach
                programs with SBC. The entire project is geared towards using
                art and literature to find stories that empower children in
                disadvantaged communities.
              </p>
              <a href="https://kuwentongpambata.com/" target="_blank" className="link-out">
                Visit Kuwentong Pambata Website
                {/* add svg */}
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.1425 2.10178C9.34471 2.02193 8.33144 1.75097 7.10269 1.28892L7.81205 0.606421C9.5878 0.782504 11.176 0.658443 12.5765 0.234236L12.9178 0.588916C12.4398 1.97207 12.2546 3.55426 12.362 5.33547L11.6527 6.01797C11.2384 4.77231 11.0067 3.74934 10.9577 2.94907L1.21388 12.324L0.398676 11.4767L10.1425 2.10178Z"
                    fill="#6B3E7D"
                  />
                </svg>
              </a>
            </ProjectBox>
            <ProjectBox>
              <h3>Creative Talk Series</h3>
              <p>
                The Creative Talk Series is primarily a collaboration with the
                deliberating editors and the production staff. Its main
                objective is to stimulate discourse about the most relevant
                topics in the contemporary literary and artistic scene, targeted
                at the Ateneo community. Two of the most successful creative
                talks put together by HEIGHTS were Art vs. Porn (2013) and
                #AlDubNation: Ang Semantika ng Kalyeserye (2015).
              </p>
              <Link to="/#contact-us" className="link-out">
                Contact us to know more
                {/* add svg */}
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.6688 10.132C10.7332 9.33282 10.9846 8.31452 11.4229 7.07708L12.1189 7.77314C11.9771 9.55195 12.1318 11.1374 12.5829 12.5295L12.2349 12.8776C10.8428 12.4264 9.25734 12.2717 7.47852 12.4135L6.78246 11.7175C8.0199 11.2792 9.03821 11.0279 9.83738 10.9634L0.276253 1.40227L1.10766 0.570869L10.6688 10.132Z"
                    fill="#6B3E7D"
                  />
                </svg>
              </Link>
            </ProjectBox>
          </ProjectBoxWrapper>
        </Main>
      </CheatWrapper>
    </OurProjectsStyles>
  )
}

export default OurProjects
